export default __webpack_public_path__ + "static/media/no-branches.fb7c344f.svg";